import { render, staticRenderFns } from "./AdminBodies.vue?vue&type=template&id=eae41240&"
import script from "./AdminBodies.vue?vue&type=script&lang=js&"
export * from "./AdminBodies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AdminBodies.vue"
export default component.exports